const header = document.querySelector(".header");
const root = document.querySelector(":root");

const initHeader = () => {
    updateHeaderHeight();   
};

const updateHeaderHeight = () => {
    root.style.setProperty("--header-height", `${header.getBoundingClientRect().height}px`);
};

export { initHeader };
